import { useEffect, useState, useCallback } from "react";
import { MonitorSmartphone } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";

export const OtherDevices = () => {
  const [count, setCount] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = useCallback(() => {
    api.get("/auth/sessions/others").then(({ data }) => setCount(data.count)).catch(() => setCount(null));
  }, []);
  useEffect(() => { load(); }, [load]);

  const signOutOthers = async () => {
    setBusy(true);
    try {
      await api.post("/auth/sessions/sign-out-others");
      toast.success("Signed out of all other devices");
      setCount(0);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Card className="mt-4 p-5 border-border flex flex-col sm:flex-row sm:items-center gap-4" data-testid="other-devices-card">
      <MonitorSmartphone className="h-6 w-6 text-muted-foreground shrink-0" />
      <div className="flex-1">
        <p className="font-medium">Signed-in devices</p>
        <p className="text-sm text-muted-foreground" data-testid="other-devices-count">
          {count === null ? "Checking…" : count === 0 ? "You're only signed in on this device." : `Also signed in on ${count} other device${count === 1 ? "" : "s"} or browser${count === 1 ? "" : "s"}.`}
        </p>
      </div>
      <AlertDialog>
        <AlertDialogTrigger asChild>
          <Button variant="outline" disabled={busy || !count} data-testid="sign-out-others-btn">Sign out other devices</Button>
        </AlertDialogTrigger>
        <AlertDialogContent data-testid="sign-out-others-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Sign out of all other devices?</AlertDialogTitle>
            <AlertDialogDescription>Every other phone, computer or browser using your account will be signed out. You stay signed in here.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="sign-out-others-cancel">Cancel</AlertDialogCancel>
            <AlertDialogAction data-testid="sign-out-others-confirm" onClick={signOutOthers}>Sign out others</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </Card>
  );
};
